import localStorage from 'store';

const KEY = 'videos';

const get = () => {
  return localStorage.get(KEY) || {};
};

const set = (id, currentTime) => {
  if (id && currentTime) {
    localStorage.set(KEY, { ...get(), [id]: currentTime });
  }
};

const remove = id => {
  if (id) {
    localStorage.set(KEY, { ...get(), [id]: undefined });
  }
};

export const videoStorage = {
  get,
  set,
  remove,
};



// WEBPACK FOOTER //
// ./src/utils/videoStorage.js